export interface GetProjectDocumentsResponse {
  count: number;
  documents: {
    documentId: number,
    documentCode: string,
    documentType: {
      documentTypeCode: string,
    },
  };
}
